import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import ListKunjunganByGetMarketing from "./ListKunjunganByGetMarketing";
import { exportPdfKunjungan } from "stores";
import "./CabangKunjunganMarketing.css";

function ListMarketingByGetMarketing(data) {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const dataCabang = data.cabang;
  const ambilKunjungan = data.kunjungan;

  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0
    )
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [sendKunjunganMarketing, setSendKunjunganMarketing] = React.useState(
    []
  );
  // const [sendDataCabang, setSendDataCabang] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_MARKETING", data: true });
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_KUNJUNGAN_MARKETING", data: false });
    setSendKunjunganMarketing(val.kunjungan);
  };

  const bukaPDF = async (idMarketing) => {
    try {
      const data = {
        tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
        tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
        idMarketing: idMarketing,
      };
      const response = await exportPdfKunjungan(data);
      // console.log(response.base64, "AASASAAS");
      // const byteCharacters = atob(response.base64);
      // const byteNumbers = new Array(byteCharacters.length);
      // for (let i = 0; i < byteCharacters.length; i++) {
      //   byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // const byteArray = new Uint8Array(byteNumbers);
      // const blob = new Blob([byteArray], { type: "application/pdf" });
      // const blobUrl = URL.createObjectURL(blob);
      // window.open(blobUrl);
      const byteCharacters = atob(response.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob from the byte array
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const newTab = window.open(blobUrl, "_blank");
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = "Kunjungan Marketing.pdf";
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Close the new tab if opened programmatically
      if (!newTab) {
        alert(
          "Pop-up blocker prevented opening the PDF in a new tab. Please allow pop-ups for this site."
        );
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // React.useEffect(() => {
  //   let tmp = [];
  //   Object.entries(data).forEach(([key, value]) => {
  //     console.log(key, "VALUEE");
  //   });
  // });

  React.useEffect(() => {
    let tmp =
      data.data &&
      data.data.map((val) => {
        return {
          ...val,
          action: (
            <div className="action-buttons-group">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-detail-blue"
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i className="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Download Pdf</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-download-red ml-2"
                  onClick={() => bukaPDF(val._id)}
                >
                  <i className="fas fa-file-download"></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListDataMarketing(tmp);
  }, [data.data]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px", // override the row height
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "50px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "13px",
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nopeg",
      minWidth: "250px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Nama",
      minWidth: "250px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "NIK",
      minWidth: "250px",
      center: true,
      selector: (row) => row.nik,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.role === "marketing" ? "Sales Marketing" : "Direct Sales Marketing",
    },
    {
      name: "Total Kunjungan",
      minWidth: "250px",
      center: true,
      selector: (row) => `${row.kunjungan.length} Kunjungan`,
    },
    {
      name: "Status",
      minWidth: "150px",
      center: true,
      selector: (row) => row.status,
      cell: (row) => {
        const isAktif = row.status === "aktif";
        return (
          <span className={`modern-badge-pill ${isAktif ? "badge-aktif" : "badge-tidakaktif"}`}>
            {isAktif ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      idCabang: idCabang,
      idMarketing: idMarketing,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir]);

  return (
    <>
      {kunjungan.detailKunjunganMarketing ? (
        <Container fluid>
          <Button
            className="btn-back-custom"
            type="button"
            onClick={handleClick}
          >
            <i className="fas fa-arrow-left"></i>
          </Button>
          <Row>
            <Col md="12">
              <Card className="kunjungan-card">
                <Card.Header className="kunjungan-card-header">
                  <Card.Title as="h3" className="kunjungan-title">
                    Daftar Marketing {dataCabang ? `: ${dataCabang.namaCabang}` : ""}
                  </Card.Title>
                  <p className="kunjungan-subtitle">
                    Tinjau dan kelola seluruh personil marketing beserta total kunjungan mereka
                  </p>
                </Card.Header>
                <Card.Body>
                  <div className="date-filter-section">
                    <div className="date-filter-title">
                      <i className="fas fa-filter"></i> Filter Periode Kunjungan
                    </div>
                    <Row>
                      <Col xs={12} sm={6} md={4} lg={3} className="mb-3 mb-sm-0">
                        <label className="small font-weight-bold text-muted mb-1">
                          <i className="fas fa-calendar-alt mr-1"></i> Tanggal Awal
                        </label>
                        <ReactDatetime
                          inputProps={{
                            className: "form-control",
                            placeholder: "Pilih Tanggal",
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                              color: "#334155",
                              backgroundColor: "#ffffff",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e1"
                            },
                          }}
                          onChange={(e) => {
                            if (typeof e === "object" && e.toDate) {
                              e.toDate().setHours(0, 0, 0, 0);
                              setTglAwal(e.toDate().setHours(0, 0, 0, 0));
                            } else {
                              setTglAwal(e);
                            }
                          }}
                          value={tglAwal}
                          initialValue={tglAwal}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <label className="small font-weight-bold text-muted mb-1">
                          <i className="fas fa-calendar-alt mr-1"></i> Tanggal Akhir
                        </label>
                        <ReactDatetime
                          inputProps={{
                            className: "form-control",
                            placeholder: "Pilih Tanggal",
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                              color: "#334155",
                              backgroundColor: "#ffffff",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e1"
                            },
                          }}
                          onChange={(e) => {
                            if (typeof e === "object" && e.toDate) {
                              e.toDate().setHours(0, 0, 0, 0);
                              setTglAkhir(e.toDate().setHours(0, 0, 0, 0));
                            } else {
                              setTglAkhir(e);
                            }
                          }}
                          value={tglAkhir}
                          initialValue={tglAkhir}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </Col>
                    </Row>
                  </div>

                  {isLoading ? (
                    <div className="loader-container">
                      <Watch
                        visible={true}
                        height="60"
                        width="60"
                        radius="30"
                        color="#F75D59"
                        ariaLabel="watch-loading"
                      />
                      <p>Memuat data list marketing...</p>
                    </div>
                  ) : (
                    <div>
                      <DataTable
                        columns={colKunjungan}
                        data={listDataMarketing}
                        customStyles={customStyles}
                        pagination
                        paginationPerPage={itemsPerPage}
                        onChangePage={handlePageChange}
                      />
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <ListKunjunganByGetMarketing
            data={sendKunjunganMarketing}
            cabang={dataCabang}
          />
        </>
      )}
    </>
  );
}

export default ListMarketingByGetMarketing;
